<template>
  <router-view/>
</template>

<script>

</script>
<style>
  html,body,#app{
    height: 100%;
  }
</style>
